export default (
  state = {
    documentNotes: [],
    mentionUsers: [],
  },
  action,
) => {
  switch (action.type) {
    /*
    ===============================
        Doc Notes Data
    ===============================
    */
    case "DOCUMENT_NOTES":
      return { ...state, documentNotes: action.payload };
    case "MENTION_USERS":
      return { ...state, mentionUsers: action.payload };
    case "ADD_NOTE":
      return {
        ...state,
        documentNotes: [action.payload, ...state.documentNotes],
      };
    case "UPDATE_NOTES":
      return { ...state, documentNotes: action.payload };
    case "NUKE_NOTE":
      return { ...state, documentNotes: [] };
    case "NUKE_QUOTATION_DATA":
      return { ...state, documentNotes: [] };
    case "REACTION_ON_DOCUMENT_PAGE_LOAD":
      return { ...state, documentNotes: action.payload.notesPayload || [] };
    default:
      return state;
  }
};
